import {createFileRoute} from '@tanstack/react-router'
import {PaymentProcess} from "@/components/wallet/PaymentProcess/PaymentProcess.tsx";
import {z} from "zod";

const swapWaitSchema = z.object({
  id: z.string().nonempty(),
})


export const Route = createFileRoute('/_mainLayout/wallet/swap/wait/')({
  component: RouteComponent,
  validateSearch: swapWaitSchema,
})

function RouteComponent() {
  return <PaymentProcess/>
}
